import { NavLink } from "react-router-dom";
import { NAV_ITEMS } from "../../lib/nav.ts";

export function Sidebar() {
  return (
    <nav className="sidebar" aria-label="Dashboard sections">
      <div className="sidebar-brand">akhshy · desk admin</div>
      {NAV_ITEMS.map((item) => (
        <NavLink
          key={item.path}
          to={item.path}
          end={item.path === "/"}
          className={({ isActive }) => `nav-link${isActive ? " active" : ""}`}
        >
          {item.label}
        </NavLink>
      ))}
    </nav>
  );
}
